/* eslint-disable camelcase */
import React from 'react'
import { Col, Row } from 'antd'
import PropTypes from 'prop-types'

import { Checkbox, RichTextInput, Input } from '~stories'

const PageCalendar = ({
  handleDescriptionChange,
  handleTitleChange,
  handleShowCalendarChange,
  pageMeta
}) => {
  const {
    title,
    description,
    show_calendar: showCalendar
  } = pageMeta
  return (
    <>
      <Input label='Title' onChange={handleTitleChange} value={title} />
      <RichTextInput label='Description' onChange={handleDescriptionChange} value={description} />
      <Row gutter={16}>
        <Col span={6}>
          <Checkbox
            checked={showCalendar}
            label='Show Calendar'
            onChange={handleShowCalendarChange}
          /></Col>
      </Row>
    </>
  )
}

PageCalendar.propTypes = {
  handleDescriptionChange: PropTypes.func,
  handleShowCalendarChange: PropTypes.func,
  handleTextChange: PropTypes.func,
  handleTitleChange: PropTypes.func,
  pageMeta: PropTypes.object.isRequired
}

PageCalendar.defaultProps = {
  pageMeta: {}
}

export default PageCalendar
